module.exports = __webpack_public_path__ + "static/media/acura-vial.694cc164.svg";